import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {ToastrService} from 'ngx-toastr';
import {LoaderService} from '@app/shared/services';
import {UserManagementService} from '@app/shared/services/user-management.service';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-institution',
  templateUrl: './institution.component.html',
  styleUrls: ['./institution.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    NgOptimizedImage,
    SelectDropDownModule,
    PageHeaderComponent
  ]

})

export class InstitutionComponent implements OnInit {
  public user_rights: any = {};
  public logo: any;
  public country_options: any = [''];
  public countries: any = [];
  public user_data: any;
  public institution_list: any = [];
  public country_data: any = [];
  public index = 0;
  public image: any;
  public institution_data = {
    institution_name: '',
    institution_address: '',
    institution_phone: '',
    institution_city: '',
    institution_country: '',
    institution_email: '',
    institution_logo: '',
    dhpo_name: '',
    dhpo_id: '',
    dhpo_password: '',
    institution_id: '',
    vat_no: '',
    user_id: ''

  }
  status: any;
  splitted: any;

  constructor(
    private loaderService: LoaderService,
    public userManagementService: UserManagementService,
    public utils: UtilsInjectable,
    private toastr: ToastrService) {

  }

  ngOnInit() {
    this.getinstitutionOptions();
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.institution_data.user_id = this.user_data.user_id;
  }

  getFileDetails($event: any) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();

    myReader.onloadend = () => {
      this.logo = myReader.result;
      this.splitted = this.logo.split(",");
      this.institution_data.institution_logo = this.splitted[1]
    }
    myReader.readAsDataURL(file);
  }

  public getinstitutionOptions() {
    this.countries = [];
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.userManagementService.getinstitutionOptions().subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.countries = result['country']['data'];
        this.country_options = this.countries;
        this.listInstitution();

        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);

      }
    });
  }

  public listInstitution() {
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.userManagementService.listInstitution().subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.loaderService.display(false);
        this.institution_list = result['data'];
        this.institution_data.institution_id = this.institution_list.INSTITUTION_SETTINGS_ID;
        this.institution_data.dhpo_name = this.institution_list.INSTITUTION_DHPO_LOGIN;
        this.institution_data.institution_phone = this.institution_list.INSTITUTION_PHONE_NO;
        this.institution_data.institution_name = this.institution_list.INSTITUTION_NAME;
        this.institution_data.dhpo_password = this.institution_list.INSTITUTION_DHPO_PASS;
        this.institution_data.dhpo_id = this.institution_list.INSTITUTION_DHPO_ID;
        this.institution_data.institution_address = this.institution_list.INSTITUTION_ADDRESS;
        this.institution_data.institution_city = this.institution_list.INSTITUTION_CITY;
        this.institution_data.institution_email = this.institution_list.INSTITUTION_EMAIL;
        this.institution_data.vat_no = this.institution_list.INSTITUTION_VAT_NO;
        this.image = result.logo_path + this.institution_list.INSTITUTION_LOGO;

        this.institution_data.institution_country = this.institution_list.INSTITUTION_STATE;
        this.setCountry();
        this.institution_data.institution_logo = this.institution_list.INSTITUTION_LOGO
      }

    });
  }

  public setCountry() {
    if (this.institution_data.institution_country) {
      for (let index = 0; index < this.countries.length; index++) {
        if (this.countries[index].STATE_ID == this.institution_data.institution_country) {
          this.country_data = this.countries[index];
          break;
        }
      }
    }
  }

  public saveInstitution() {
    const postdata = {
      institution_name: this.institution_data.institution_name,
      institution_address: this.institution_data.institution_address,
      institution_phone: this.institution_data.institution_phone,
      institution_city: this.institution_data.institution_city,
      institution_state: this.institution_data.institution_country,
      institution_logo: this.institution_data.institution_logo,
      dhpo_name: this.institution_data.dhpo_name,
      dhpo_id: this.institution_data.dhpo_id,
      dhpo_password: this.institution_data.dhpo_password,
      institution_id: this.institution_data.institution_id,
      institution_email: this.institution_data.institution_email,
      vat_no: this.institution_data.vat_no,
      user_id: this.user_data.user_id,

    };
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.userManagementService.saveInstitution(postdata).subscribe((result: any) => {
      this.status = result['status'];
      if (result['status'] == 'Success') {
        this.toastr.success(result['status'])
        this.loaderService.display(false);
        this.listInstitution();
      } else {
        this.loaderService.display(false);
      }
    });
  }

  edit(data: any) {
    this.institution_data.institution_name = data.INSTITUTION_NAME
    this.institution_data.institution_address = data.INSTITUTION_ADDRESS
    this.institution_data.institution_phone = data.INSTITUTION_PHONE_NO
    this.institution_data.institution_city = data.INSTITUTION_CITY
    this.institution_data.institution_country = data.TIN_NUMBER
    this.institution_data.institution_email = data.INSTITUTION_EMAIL
    this.institution_data.vat_no = data.INSTITUTION_VAT_NO
  }

  getcountry() {
    this.institution_data.institution_country = this.country_data.STATE_ID;
  }
}
